/**
 * The cookie that remembers whether the person keeps the sidebar collapsed.
 *
 * Written by SidebarProvider (components/ui/sidebar.tsx) every time it is toggled; read
 * by the shell frame (components/app-shell-frame.tsx) after hydration, by the admin
 * layout on its own server, and by the inline head script (lib/shell/sidebar-bootstrap.tsx)
 * before the first paint. One constant, in a file with no "use client", so the
 * server-rendered root layout can use it too (a constant imported from a client module
 * is a client reference on the server, not a string).
 */
export const SIDEBAR_COOKIE_NAME = 'sidebar_state'

/** Written on <html> by the head script from the first paint until React owns the state. */
export const SIDEBAR_PRELOAD_ATTRIBUTE = 'data-sidebar-state'
